export enum LicenseUserStatus {
  Deactivated,
  Active,
  Invited,
  Paused
}
